import { useState } from "react";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { MessageSquare, Send } from "lucide-react";
import { toast } from "sonner";
import { fmtDate } from "@/components/DatePicker";

// HR ↔ employee thread on a change request. side = "hr" | "employee"
export function RequestThread({ requestId, messages = [], side, closed, onSent, compact = false }) {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { await api.post(`/change-requests/${requestId}/messages`, { text }); setText(""); toast.success(side === "hr" ? "Question sent to the employee" : "Reply sent to HR"); onSent?.(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  return (
    <div className={compact ? "space-y-2" : "space-y-3"} data-testid={`thread-${requestId}`}>
      {!compact && <div className="font-display font-semibold flex items-center gap-1.5"><MessageSquare className="w-4 h-4 text-primary" /> Messages with employee <span className="text-xs text-muted-foreground font-normal">({messages.length})</span></div>}
      {messages.length > 0 && (
        <ul className="space-y-1.5">
          {messages.map((m, i) => (
            <li key={i} data-testid={`thread-msg-${i}`} className={`text-sm rounded-xl px-3 py-2 max-w-[90%] ${m.role === side ? "ml-auto bg-primary text-primary-foreground" : "bg-muted"}`}>
              <div className="whitespace-pre-wrap">{m.text}</div>
              <div className={`text-[10px] mt-0.5 ${m.role === side ? "text-primary-foreground/70" : "text-muted-foreground"}`}>{m.by} · {m.role === "hr" ? "HR" : "Employee"} · {fmtDate(m.at.slice(0, 10))}</div>
            </li>
          ))}
        </ul>
      )}
      {!closed && (
        <div className="flex gap-2 items-end">
          <Textarea data-testid={`thread-input-${requestId}`} rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder={side === "hr" ? "Ask the employee a clarifying question…" : "Reply to HR…"} className="text-sm" />
          <Button size="sm" data-testid={`thread-send-${requestId}`} disabled={busy || !text.trim()} onClick={send}><Send className="w-3.5 h-3.5 mr-1" /> Send</Button>
        </div>
      )}
      {closed && messages.length === 0 && <p className="text-xs text-muted-foreground">No messages.</p>}
    </div>
  );
}
